import Service from "../Service";

const resource = "workerallowance/"; //WorkerAlowanceController

export default {
    get(adm, requestID) {
        return Service.post(resource, adm, {
            params: { requestID: requestID },
        });
    },

    save(wac, requestID) {
        return Service.post(resource + "save", wac, {
            params: { requestID: requestID },
        });
    },
    birthday(wac, requestID) {
        return Service.post(resource + "birthday", wac, {
            params: { requestID: requestID },
        });
    },

    pagination(dtr, requestID) {
        return Service.post(resource + "pagination", dtr, {
            params: { requestID: requestID },
        });
    },
    // excel(dtr) {
    //     console.log("dtr", dtr);
    //     const obj =  {
    //         TypePayroll: dtr.filter.TypePayroll,
    //         TypeGroup: dtr.filter.TypeGroup,
    //         TypeIncident: dtr.filter.TypeIncident,
    //         WacBeginDate: dtr.filter.WacBeginDate,
    //         WacEndDate: dtr.filter.WacEndDate,
    //         Everybody: dtr.filter.Everybody,
    //     };
    //     return Service.post(
    //         resource + "report", {}, {
    //             responseType: "blob",
    //             headers: {
    //                 "Content-Type": "application/json",
    //             },
    //             params: {
    //                 // typepayroll: dtr.filter.TypePayroll,
    //                 // typegroup: dtr.filter.TypeGroup,
    //                 // typeincident: dtr.filter.TypeIncident,
    //                 // init: dtr.filter.WacBeginDate,
    //                 // end: dtr.filter.WacEndDate,
    //                 // Everybody: dtr.filter.Everybody,
    //                 obj
    //             },
    //         }
    //     );
    // },
    excel(dtr) {
        return Service.post(resource + "report", dtr.filter, {
            params: { },
            responseType: "blob",
            headers: {
                "Content-Type": "application/json",
            },
        });
    },
    saveMassive(hmw, usr) {
        console.log(hmw);
        return Service.post(resource + "saveMassive", hmw, {
            params: { usrID: usr },
        });
    },
    birthdayDemo(NtpName, NtpPaternalSurname, requestID) {
        return Service.post(resource + "birthdayDemo", {}, {
            params: {
                NtpName: NtpName,
                NtpPaternalSurname: NtpPaternalSurname,
                requestID: requestID 
            },
        });
    },
    sendBirthday(obj, requestID) {
        return Service.post(resource + "sendBirthday", obj, {
            params: {
                requestID: requestID 
            },
        });
    },
    sendBirthdayMonth(formData, requestID) {
        return Service.post(resource + "sendBirthdayMonth", formData, {
            params: { requestID },
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    verificationOption(wac, requestID) {
        return Service.post(resource + "verificationOption", wac, {
            params: { requestID: requestID },
        });
    },
};